/**
 * Copyright: ThoughtSpot Inc. 2026
 *
 * @fileoverview Helpers for text that is about to be rendered as HTML.
 */
// Finds the '<' that starts an accidental comment (the cases are listed in the function's comment below).
// Real tags, real comments and plain text like 'a < b' don't match.
const ACCIDENTAL_COMMENT_START = /<(?=\/(?![a-zA-Z])|\?|!(?!--|[Dd][Oo][Cc][Tt][Yy][Pp][Ee]|\[CDATA\[))/g;
/**
 * Stops the browser from hiding part of a text when the text is shown as HTML.
 *
 * Some characters make the browser think a comment has started, so it hides everything after them up to the
 * next '>'. For example, "Duration </= 30 Days" shows as just `Duration`. We call this an accidental comment
 * (the HTML spec calls it a "bogus comment"). It starts with:
 *   - </ followed by anything other than a letter, like `</=` or `</ `
 *   - <?
 *   - <!, unless it starts a real "<!-- -->" comment, a doctype or CDATA
 *
 * This function replaces that < with &lt;, so the browser shows the text as written. Real HTML is left as is.
 *
 * Only use it on text that will be shown as HTML. On plain text (React children, innerText) you would see
 * &lt; on screen. Non-string values are returned unchanged.
 */
export function escapeAccidentalComments(text) {
    if (typeof text !== 'string' || text.indexOf('<') === -1) {
        return text;
    }
    return text.replace(ACCIDENTAL_COMMENT_START, '&lt;');
}
//# sourceMappingURL=accidental-comments.js.map